import { ListOfEvents } from "./ListOfEvents";
import { BasePage } from "../../common/BasePage";
import { DatePanel } from "./DatePanel";
import { AdminService } from "../../../services/AdminService";
import { AdminPanel } from "../../common/AdminPanel";
import { useContext, useEffect } from "react";
import { storeContext } from "../../../store/root-store";
import { FullListOfTags } from "../filter/FullListOfTags";
import { FooterMainButton } from "../../common/FooterMainButton";
import { observer } from "mobx-react-lite";
import { FullListOfDates } from "../filter/FullListOfDates";
import { useNavigate } from "react-router-dom";
import { AdminDatesPanel } from "./panels/TagsPanel/AdminDatesPanel";
import { Settings } from "../../../store/Settings";
import { DateButtons } from "../../../enums/DateButtons";

/**
 * true - показать filter, false - ленту
 * @param showMenuStatus
 * @param listOfSelectedTags
 * @param listOfSelectedDates
 * @returns
 */
const showMenuFilter = (
  showMenuStatus: boolean,
  listOfSelectedTags: any[],
  listOfSelectedDates: any[]
) => {
  return (
    showMenuStatus || !listOfSelectedDates.length || !listOfSelectedTags.length
  );
};

export const ListPage = observer(() => {
  const {
    settingsGl,
    filterDatesGl,
    eventsStore,
    filterTagGl,
    adminDateFilterGl,
  } = useContext(storeContext);
  const nav = useNavigate();

  const getEvents = (currentDayFilter: DateButtons, chunkLength: number) => {
    const timeInterval = Settings.getTimeInterval(currentDayFilter);
    const selectedEvents = settingsGl.selectedListOfEvents;
    const showOnlyUnique = settingsGl.showOnlyUnique;
    return async (currentPage: number = 0) => {
      return await eventsStore.getListOfPreviewEvents(
        timeInterval.startSec,
        timeInterval.finishSec,
        // settingsGl.selectedTag?.id ? [settingsGl.selectedTag.id] : [],
        filterTagGl.listOfSelectedTags.map((el) => el.id),
        currentPage,
        chunkLength,
        showOnlyUnique,
        settingsGl.currentDayFilter,
        timeInterval,
        filterDatesGl.listOfSelecedDates,
        Array.from(adminDateFilterGl.listOfSelectedDates)
      );
      // return res;
    };
  };

  // useEffect(() => {
  //   if (
  //     !filterTagGl.listOfSelectedTags.length
  //   ) {
  //     nav("/filter");
  //   }
  // }, [
  //   filterDatesGl.listOfSelecedDates,
  //   filterTagGl.listOfSelectedTags,
  //   Array.from(adminDateFilterGl.listOfSelectedDates).length,
  // ]);
  return (
    <BasePage>
      {/* {AdminService.getService().isAdmin() && <AdminPanel />} */}
      {/* <div> */}
      {/* </div> */}
      {AdminService.getService().isAdmin() && (
        <>
          <AdminDatesPanel></AdminDatesPanel>
        </>
      )}
      <ListOfEvents
        loadEvents={getEvents(
          settingsGl.currentDayFilter,
          Settings.chunkLength
        )}
      ></ListOfEvents>
      {/* <FooterMainButton buttonText="Фильтр" navTo="/filter"></FooterMainButton> */}
    </BasePage>
  );
});
